import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import FontAwesome from 'components/FontAwesome/FontAwesome';
import { formatDurationMillis, millisToHours } from 'utils/time';
import { editPanelBlock as block } from './utils';

export interface ClipSelectDetailCardTimecodesProps {
  clipStartMillis: number;
  clipEndMillis: number;
}

function formatDuration(value: number) {
  return formatDurationMillis(value, {
    hour: millisToHours(value) >= 1 ? 'numeric' : undefined,
    minute: '2-digit',
    second: '2-digit',
    trim: false,
  });
}

const ClipSelectDetailCardTimecodes: React.FC<ClipSelectDetailCardTimecodesProps> = ({
  clipStartMillis,
  clipEndMillis,
}) => (
  <Spacer
    orientation="horizontal"
    space="6px"
    align="center"
    justify="center"
    className={block('timecodes')}
  >
    <FontAwesome icon="clock" />
    <span className={block('timecodes-text')}>
      {formatDuration(clipStartMillis)} - {formatDuration(clipEndMillis)}
    </span>
  </Spacer>
);

export default ClipSelectDetailCardTimecodes;
